import { useState, useRef } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { UploadCloud, Loader2, X } from "lucide-react";

export default function ImageUpload({ path, onChange, className = "" }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const pick = () => ref.current?.click();
  const preview = path ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}` : null;

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Imagen subida");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo subir la imagen");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className={className}>
      <input ref={ref} type="file" accept="image/*" onChange={onFile} className="hidden" />
      {preview ? (
        <div className="relative w-full aspect-[16/10] rounded-lg overflow-hidden border border-[#3A3229] group">
          <img src={preview} alt="preview" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 flex items-center justify-center gap-2"
               style={{ transitionProperty: "opacity", transitionDuration: "200ms" }}>
            <button type="button" onClick={pick} className="btn-ghost-gold px-3 py-1.5 rounded-full text-xs">Cambiar</button>
            <button type="button" onClick={() => onChange(null)} className="p-1.5 rounded-md bg-rose-500/20 border border-rose-500/60 text-rose-300"><X size={13} /></button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={pick} disabled={busy}
                className="w-full aspect-[16/10] rounded-lg border border-dashed border-[#3A3229] hover:border-[#D4AF37] flex flex-col items-center justify-center gap-2 text-sm text-[#F5EFE0]/60 hover:text-[#E8C87A]"
                style={{ transitionProperty: "border-color,color", transitionDuration: "200ms" }}>
          {busy ? <Loader2 size={18} className="animate-spin" /> : <UploadCloud size={22} />}
          {busy ? "Subiendo…" : "Subir imagen"}
        </button>
      )}
    </div>
  );
}
